// Google Analytics ładowany dopiero po zgodzie użytkownika na cookies analityczne.

export const GA_ID = 'G-ZK6JHFKZ3B';
const CONSENT_KEY = 'cookieConsent'; // 'accepted' | 'rejected'
export const OPEN_COOKIE_SETTINGS_EVENT = 'nekrodruk:open-cookie-settings';

export const getCookieConsent = () => {
    try {
        return localStorage.getItem(CONSENT_KEY);
    } catch {
        return null;
    }
};

const saveCookieConsent = (value) => {
    try {
        localStorage.setItem(CONSENT_KEY, value);
    } catch {
        // brak dostępu do localStorage – decyzja obowiązuje tylko w tej sesji
    }
};

let analyticsLoaded = false;

export const loadAnalytics = () => {
    window[`ga-disable-${GA_ID}`] = false;
    if (analyticsLoaded) {
        return;
    }
    analyticsLoaded = true;

    window.dataLayer = window.dataLayer || [];
    window.gtag = function gtag() {
        window.dataLayer.push(arguments);
    };
    window.gtag('js', new Date());
    window.gtag('config', GA_ID);

    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
    document.head.appendChild(script);
};

// Usuwa cookies Google Analytics (_ga, _ga_XXXX) z bieżącej domeny i domeny nadrzędnej
const removeAnalyticsCookies = () => {
    const domains = ['', window.location.hostname, `.${window.location.hostname.replace(/^www\./, '')}`];
    document.cookie.split(';').forEach((cookie) => {
        const name = cookie.split('=')[0].trim();
        if (name === '_ga' || name.startsWith('_ga_') || name === '_gid') {
            domains.forEach((domain) => {
                document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/${domain ? `; domain=${domain}` : ''}`;
            });
        }
    });
};

export const acceptAnalytics = () => {
    saveCookieConsent('accepted');
    loadAnalytics();
};

export const rejectAnalytics = () => {
    saveCookieConsent('rejected');
    // Wycofanie zgody: wyłączamy wysyłanie danych i kasujemy już zapisane cookies
    window[`ga-disable-${GA_ID}`] = true;
    removeAnalyticsCookies();
};

export const openCookieSettings = () => {
    window.dispatchEvent(new Event(OPEN_COOKIE_SETTINGS_EVENT));
};
